import { FormControl, FormControlProps, SkeletonText } from "@chakra-ui/react";
import { CustomSelect } from "@ui/application";
import { LoadingDots } from "@ui/loading";

export function LocationSelectorSkeleton(props: Omit<FormControlProps, "id">) {
  return (
    <FormControl id="loading-user-location" {...props}>
      <SkeletonText fontSize="xs" noOfLines={1} w="20%" mb="2"></SkeletonText>
      <CustomSelect
        name="UserLocation"
        id="loading-user-locations-select"
        colorScheme="blue"
        value={<LoadingDots color="blueGray.300" />}
      ></CustomSelect>
    </FormControl>
  );
}
